// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1YHnA","requiredAsterisk":"Info_requiredAsterisk__4h64y"};